import * as tslib_1 from "tslib";
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';
import { ConfigService } from './config.service';
import { CapacitacionService } from './capacitacion.service';
import { MONTHS } from '../utils/constants';
import { throwError } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "./config.service";
import * as i3 from "./capacitacion.service";
const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
const EXCEL_EXTENSION = '.xlsx';
const WORK_SHEET_NAMES = {
    REPORTE_INICIAL: 'Capacitaciones',
    ASISTENCIA: 'Asistentes'
};
export class ExcelService {
    constructor(http, configService, capacitacionService) {
        this.http = http;
        this.configService = configService;
        this.capacitacionService = capacitacionService;
        this.jsonContent = {
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                Authorization: sessionStorage.getItem("batoken"),
                User: sessionStorage.getItem("userid"),
            }),
        };
        this.headers = new HttpHeaders();
    }
    exportAsExcelRows(rows) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            let rowsCapacitaciones = rows.map((capacitacion) => this.buildRowExport(capacitacion));
            let rowAsistentes = this.buildAsistentesExport(rows);
            const wsReportInic = XLSX.utils.json_to_sheet(rowsCapacitaciones);
            const wsReportAsist = XLSX.utils.json_to_sheet(rowAsistentes);
            const workbook = {
                Sheets: {
                    Capacitaciones: wsReportInic,
                    Asistentes: wsReportAsist,
                },
                SheetNames: [
                    WORK_SHEET_NAMES.REPORTE_INICIAL,
                    WORK_SHEET_NAMES.ASISTENCIA,
                ],
            };
            const excelBuffer = XLSX.write(workbook, {
                bookType: "xlsx",
                type: "array",
            });
            this.saveAsExcelFile(excelBuffer, "Reporte");
        });
    }
    saveAsExcelFile(buffer, fileName) {
        const data = new Blob([buffer], {
            type: EXCEL_TYPE,
        });
        FileSaver.saveAs(data, fileName + "_tabla_" + new Date().getTime() + EXCEL_EXTENSION);
    }
    buildRowExport(rows) {
        return {
            "Id capacitación": rows.capacitacion.capacitacionId,
            "Nombre contratista": rows.capacitacion.nombreTrabajador +
                " " +
                rows.capacitacion.apellidoPaterno,
            "Tipo de capacitación": rows.capacitacion.capacitacionTypeDescription,
            "Nombre capacitación": rows.capacitacion.name,
            Categoría: rows.capacitacion.categoryDescription,
            Foco: rows.capacitacion.focoDescription,
            Enfoque: rows.capacitacion.enfoqueDescription,
            Zona: rows.capacitacion.zoneDescription,
            Ejecutor: rows.capacitacion.ejecutorDescription,
            Relator: rows.capacitacion.relatorDescription,
            Observación: rows.capacitacion.observation,
            "Mes de planificación": rows.capacitacion.month,
            "Año de planificación": rows.capacitacion.year,
            "Fecha planificación": rows.capacitacion.day +
                "/" +
                rows.capacitacion.month +
                "/" +
                rows.capacitacion.year,
            "Fecha de ejecución real": `${rows.capacitacion.realExecutionDate == null
                ? "-"
                : rows.capacitacion.realExecutionDate} `,
            "Duración real (HH)": `${rows.capacitacion.realHours == null ? "-" : rows.capacitacion.realHours} `,
            "Horas Estimadas": `${rows.capacitacion.estimatedHours == null
                ? "-"
                : rows.capacitacion.estimatedHours} `,
            "Horas Teoricas Real": `${rows.capacitacion.realTheoryHours == null
                ? "-"
                : rows.capacitacion.realTheoryHours} `,
            "Horas Prácticas Real": `${rows.capacitacion.realPracticeHours == null
                ? "-"
                : rows.capacitacion.realPracticeHours} `,
            "Asistentes Estimados": rows.capacitacion.estimatedAssistants,
            "Asistentes Reales": `${rows.capacitacion.realAssistants == null
                ? "-"
                : rows.capacitacion.realAssistants} `,
            "Fecha de creación": rows.capacitacion.creationDate,
            Estado: rows.capacitacion.stateShortDescription,
        };
    }
    buildAsistentesExport(rows) {
        //const assitance = capacitacionWithAssistances;
        let arrayAssitentes = [];
        rows.forEach((row) => {
            if (row.assistanceRegistries != null &&
                row.assistanceRegistries != undefined &&
                row.assistanceRegistries.length > 0) {
                row.assistanceRegistries.map((capacitacionItem) => {
                    let asistente = this.buildRowAsistentes(capacitacionItem);
                    arrayAssitentes.push(asistente);
                });
            }
        });
        return arrayAssitentes;
    }
    buildRowAsistentes(asistente) {
        return {
            "ID Capacitacion": asistente.capacitacionId,
            "ID Asistencia": asistente.assistanceRegistryId,
            "Rut Trabajador": asistente.rutTrabajador,
            "Nombre Trabajador": asistente.nombreTrabajador +
                " " +
                asistente.apellidoPaterno +
                " " +
                asistente.apellidoMaterno,
        };
    }
    // public async exportAsExcelFile(offset: number, quantity: number, year: string, month: string, contratista: string, empresa: string, zona: string) {
    //   await this.capacitacionService.list(offset, quantity, year, month, contratista, empresa, zona)
    //     .then(capacitacionesWithAssistances => {
    //       this.rows = capacitacionesWithAssistances.map(capacitacionWithAssistances => this.buildRow(capacitacionWithAssistances));
    //       this.rowsAssitance = capacitacionesWithAssistances.map(capacitacionWithAssistances => capacitacionWithAssistances.assistanceRegistries);
    //     })
    //     .catch(error => {
    //       console.error(error);
    //     });
    //   const rowsnonull = this.rowsAssitance.filter(value => JSON.stringify(value) !== '[]');
    //   let cleanJSON = "[" + JSON.stringify(rowsnonull).replace(/[\[\]&]+/g, '') + "]";
    //   const assitanceReady = JSON.parse(cleanJSON);
    //   const rowsfinal = assitanceReady.map(assitanceReady => this.buildRowAssitances(assitanceReady));
    //   const wsReportInic: XLSX.WorkSheet = XLSX.utils.json_to_sheet(this.rows);
    //   const wsReportAsist: XLSX.WorkSheet = XLSX.utils.json_to_sheet(rowsfinal);
    //   const workbook: XLSX.WorkBook = {
    //     Sheets: {
    //       'Tabla': wsReportInic,
    //       'Asistencia': wsReportAsist,
    //     }, SheetNames: [WORK_SHEET_NAMES.REPORTE_INICIAL, WORK_SHEET_NAMES.ASISTENCIA]
    //   };
    //   const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    //   this.saveAsExcelFile(excelBuffer, 'Reporte');
    // }
    // public async exportAsExcel(rows: any, rowsAssitance: any) {
    //   const rowsnonull = rowsAssitance.filter(value => JSON.stringify(value) !== '[]');
    //   let cleanJSON = "[" + JSON.stringify(rowsnonull).replace(/[\[\]&]+/g, '') + "]";
    //   const assitanceReady = JSON.parse(cleanJSON);
    //   const rowsfinal = assitanceReady.map(assitanceReady => this.buildRowAssitances(assitanceReady));
    //   const wsReportInic: XLSX.WorkSheet = XLSX.utils.json_to_sheet(rows);
    //   const wsReportAsist: XLSX.WorkSheet = XLSX.utils.json_to_sheet(rowsfinal);
    //   const workbook: XLSX.WorkBook = {
    //     Sheets: {
    //       'Tabla': wsReportInic,
    //       'Asistencia': wsReportAsist,
    //     }, SheetNames: [WORK_SHEET_NAMES.REPORTE_INICIAL, WORK_SHEET_NAMES.ASISTENCIA]
    //   };
    //   const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    //   this.saveAsExcelFile(excelBuffer, 'Reporte');
    // }
    // buildRow(capacitacionWithAssistances: any): any {
    //   return {
    //     "ID": capacitacionWithAssistances.capacitacion.capacitacionId,
    //     "Rut Empresa": capacitacionWithAssistances.capacitacion.rutContratista,
    //     "Nombre Empresa": capacitacionWithAssistances.capacitacion.nombreContratista,
    //     "Nombre Contratista": capacitacionWithAssistances.capacitacion.nombreTrabajador + " " + capacitacionWithAssistances.capacitacion.apellidoPaterno,
    //     "Tipo de capacitación": capacitacionWithAssistances.capacitacion.capacitacionTypeDescription,
    //     "Nombre": capacitacionWithAssistances.capacitacion.name,
    //     "Categoría": capacitacionWithAssistances.capacitacion.categoryDescription,
    //     "Foco": capacitacionWithAssistances.capacitacion.focoDescription,
    //     "Enfoque": capacitacionWithAssistances.capacitacion.enfoqueDescription,
    //     "Zona": capacitacionWithAssistances.capacitacion.zoneDescription,
    //     "Ejecutor": capacitacionWithAssistances.capacitacion.ejecutorDescription,
    //     "Relator": capacitacionWithAssistances.capacitacion.relatorDescription,
    //     "Observación": capacitacionWithAssistances.capacitacion.observation,
    //     "Mes de planificación": this.getMonthLabel(capacitacionWithAssistances.capacitacion.month),
    //     "Fecha de ejecución real": capacitacionWithAssistances.capacitacion.realExecutionDate,
    //     "Cantidad de asistentes": capacitacionWithAssistances.capacitacion.realAssistants,
    //     "Duración real (HH)": `${capacitacionWithAssistances.capacitacion.realHours}hs`,
    //     "Horas Estimadas": `${capacitacionWithAssistances.capacitacion.estimatedHours == null ? "- " : capacitacionWithAssistances.capacitacion.estimatedHours}hs`,
    //     "Horas Teoricas Real": `${capacitacionWithAssistances.capacitacion.realTheoryHours == null ? "- " : capacitacionWithAssistances.capacitacion.realTheoryHours}hs`,
    //     "Horas Prácticas Real": `${capacitacionWithAssistances.capacitacion.realPracticeHours == null ? "- " : capacitacionWithAssistances.capacitacion.realPracticeHours}hs`,
    //     "Asistentes Estimados": capacitacionWithAssistances.capacitacion.estimatedAssistants,
    //     "Asistentes Reales": capacitacionWithAssistances.capacitacion.realAssistants,
    //     "Fecha de creación": capacitacionWithAssistances.capacitacion.creationDate,
    //     "Fecha de cierre": capacitacionWithAssistances.capacitacion.cierreDate,
    //     "Estado": capacitacionWithAssistances.capacitacion.stateShortDescription,
    //   };
    // }
    // buildRowAssitances(capacitacionWithAssistances: any): any {
    //   //const assitance = capacitacionWithAssistances;
    //   if (capacitacionWithAssistances != null && capacitacionWithAssistances != undefined)
    //     return {
    //       "ID Capacitacion": capacitacionWithAssistances.capacitacionId,
    //       "ID Asistencia": capacitacionWithAssistances.assistanceRegistryId,
    //       "Rut Trabajador": capacitacionWithAssistances.rutTrabajador,
    //       "Nombre Trabajador": capacitacionWithAssistances.nombreTrabajador + " " + capacitacionWithAssistances.apellidoPaterno + " " + capacitacionWithAssistances.apellidoMaterno
    //     };
    // }
    getMonthLabel(id) {
        return MONTHS[id - 1].label;
    }
    downloadCapacitaciones(params) {
        console.log(JSON.stringify(params));
        let hp = new HttpParams();
        Object.keys(params).forEach((k) => {
            const v = params[k];
            if (v !== null && v !== undefined && v !== "") {
                hp = hp.set(k, String(v));
            }
        });
        return this.http
            .get(this.configService.API_URL +
            "/capacitaciones/report/excel/capacitacion", {
            params: hp,
            observe: "response",
            responseType: "blob",
        })
            .pipe(tap((res) => {
            const blob = res.body;
            const contentType = res.headers.get("Content-Type") || "";
            if (contentType.includes("application/json")) {
                readBlobAsText(blob).then((text) => {
                    try {
                        const err = JSON.parse(text);
                        throw new Error(err.message || "Error al generar el archivo.");
                    }
                    catch (_a) {
                        throw new Error(text || "Error al generar el archivo.");
                    }
                });
                return;
            }
            const dispo = res.headers.get("Content-Disposition") || "";
            const filename = extractFilename(dispo) || `capacitaciones_${Date.now()}.xlsx`;
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.href = url;
            a.download = filename;
            document.body.appendChild(a);
            a.click();
            a.remove();
            window.URL.revokeObjectURL(url);
        }), map(() => void 0), catchError((err) => {
            if (err.error instanceof Blob) {
                return new Promise((_, reject) => {
                    readBlobAsText(err.error).then((text) => {
                        try {
                            const j = JSON.parse(text);
                            reject(new Error(j.message || "Error al descargar el Excel."));
                        }
                        catch (_a) {
                            reject(new Error(text || "Error al descargar el Excel."));
                        }
                    });
                });
            }
            return throwError(() => err);
        }));
    }
}
ExcelService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function ExcelService_Factory() { return new ExcelService(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(i2.ConfigService), i0.ɵɵinject(i3.CapacitacionService)); }, token: ExcelService, providedIn: "root" });
function extractFilename(disposition) {
    const matchQuoted = /filename\*?=(?:UTF-8''|)(["']?)([^;"']+)\1/i.exec(disposition);
    if (matchQuoted && matchQuoted[2]) {
        try {
            return decodeURIComponent(matchQuoted[2]);
        }
        catch (_a) {
            return matchQuoted[2];
        }
    }
    return null;
}
function readBlobAsText(blob) {
    return new Promise((resolve, reject) => {
        const fr = new FileReader();
        fr.onload = () => resolve(fr.result || '');
        fr.onerror = () => reject(fr.error || new Error('No se pudo leer el error.'));
        fr.readAsText(blob);
    });
}
